// extracted by mini-css-extract-plugin
module.exports = {"admin_table_avatar":"CustomerManagement_admin_table_avatar__3M55X","rupees_logo_sizing":"CustomerManagement_rupees_logo_sizing__2s1AW"};